var _rect, _defs, _style;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect-outline",
    x: 0.5,
    y: 0.5,
    width: "100%",
    height: "100%",
    rx: 7.5,
    stroke: "url(#paint1_linear_26_113)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_113",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgba(255, 255, 255, 0.05)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n#rect-outline {\n  width: calc(100% - 1px);\n  height: calc(100% - 1px);\n}\n")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/searchBar.5e95941fed8b6ccfb63de90155d9d903.svg";
export { ForwardRef as ReactComponent };